import { render, staticRenderFns } from "./ProjectDocumentTemplateDetailNewForm.vue?vue&type=template&id=74dcd35e&"
import script from "./ProjectDocumentTemplateDetailNewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateDetailNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports